<!-- ProductsSection.vue -->
<template>
  <section class="products-section">
    <div class="container">
      <h2 class="section-title">ໝວດໝູ່ຜະລິດຕະພັນ</h2>
      <div v-if="isLoading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>ລໍຖ້າແປັບໜຶ່ງເດີ້...</p>
      </div>

      <div class="products-grid">
        <div
          v-for="product in products"
          :key="product.id"
          class="product-card"
          @click="navigateToProduct(product.link)"
          @keydown.enter="navigateToProduct(product.link)"
          tabindex="0"
          role="button"
          :aria-label="`ເບິ່ງລາຍລະອຽດ ${product.title}`"
        >
          <div class="product-icon-wrapper">
            <img
              :src="product.icon"
              :alt="product.title"
              class="product-icon"
              loading="lazy"
            />
          </div>
          <h3 class="product-title">{{ product.title }}</h3>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useRouter } from "vue-router";
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import gql from "graphql-tag";

const router = useRouter();

const GET_PRODUCTS = gql`
  query GetProductIcons {
    products_icon_ProductsSection(order_by: { id: asc }) {
      id
      icon
      title
      link
    }
  }
`;
const { result, loading: isLoading } = useQuery(GET_PRODUCTS);
const products = computed(
  () => result.value?.products_icon_ProductsSection ?? []
);

// Navigate to product page
const navigateToProduct = async (link) => {
  if (!link) return;

  try {
    await router.push(link);
  } catch (error) {
    console.error("Navigation error:", error);
  }
};
</script>

<style scoped>
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 300px;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ea2127;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.products-section {
  padding: 4rem 0;
  background-color: #f5f8fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 3rem;
  color: #344873;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 900px;
  margin: 0 auto;
}

.product-card {
  background: #f5f8fa;
  border-radius: 1rem;
  padding: 3rem 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  outline: none;
}

.product-card:hover,
.product-card:focus {
  transform: translateY(-0.75rem);
  box-shadow: 0 1.25rem 1.5625rem -0.3125rem rgba(0, 0, 0, 0.1);
  border-color: #ebe5e5;
  background: #ffffff;
}

.product-card:active {
  transform: translateY(-4px);
}

.product-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
}

.product-icon {
  width: 120px;
  height: 120px;
  object-fit: contain;
  user-select: none;
  pointer-events: none;
}

.product-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #344873;
  margin: 0;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .products-section {
    padding: 1.5rem 0;
  }

  .section-title {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .products-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }

  .product-card {
    padding: 1rem 0.5rem;
  }

  .product-icon {
    width: 80px;
    height: 80px;
  }

  .product-title {
    font-size: 1rem;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .products-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>